import { Injectable } from "@angular/core";
import { appConfig } from "../core-config";
import { Moment } from "moment";
import * as moment from "moment";
import { VersionModel } from "../shared/models/version.model";
import { CoreCOMService } from "./com.service";
import { CoreLogService } from "./log.service";
import { StorageHive, LocalKeys } from "./valueStorage.service";
import { YourAppServer } from "./YourAppServer.service";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { Router } from "@angular/router";
import { BottomSheetHelperService } from "./bottomSheetHelper.service";
import { AnnounceDialogComponent, WarningdialogComponent } from "../modalDialogs";
import { AnounceModalResult } from "../shared/contentTypes";
import { environment } from "../../../environments/environment";
import { ClientType } from "./com/comEnvironmentClient";
import { CoreLanguageService } from "./language.service";
import { nearer } from "../../../../node_modules/@types/q";


/** CoreUpdateService */

@Injectable()
export class CoreUpdateService {
    /** zeitpunkt, wann zuletzt eine versions prüfung stattgefunden hat */
    private is_redirected: boolean = false;
    /** zeitpunkt, wann zuletzt eine versions prüfung stattgefunden hat */
    private last_version_check: Moment = null;

    constructor(private _objObsInjectHelper: CircularInjectionHelper,
        private _router: Router,
        private _bottomSheetHelperService: BottomSheetHelperService,
        private _coreCOMService: CoreCOMService,
        private _coreLogService: CoreLogService,
        private _coreLanguageService: CoreLanguageService) {
    }

    /** gibt aus, ob ein prüfung daten bereits vom server erfolgreich abrufen konnte */
    public get has_checked(): boolean {
        return this.last_version_check != null;
    }

    // todo bind "check(false);" to has internet back
    /** checks for new version and notify, force or suppress
     * @param force erzwingt (wenn möglich) die sofortige prüfung, es umgeht den automatischen zyklus
     */
    public check(force: boolean = false): Promise<void> {
        const me = this;

        // if it is redirected for force update or client is a browser (not mobile has no version)
        if (me.is_redirected || !me._objObsInjectHelper.coreCOMService.environment.client.isMobile) {
            return Promise.resolve();
        } else if (!force && me.last_version_check && (!appConfig.update.automatic || me.last_version_check.diff(moment(), 'minutes', false) < appConfig.update.interval)) {
            return Promise.resolve();
        } else if (!me._objObsInjectHelper.coreCOMService.environment.networkInformation.isOnline) {
            return me.checkStoragedVersion();
        } else {
            return new Promise<void>(async (resolve) => {
                try {
                    // get new version from server
                    const new_version = await me.getNewVersionFromServer();
                    // save it in storage
                    try {
                        await me._objObsInjectHelper.coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.versionData, new_version);
                    } catch (error) { /* suppress saving error */
                        me._objObsInjectHelper.coreLogService.error("CoreUpdateService.check", "valueStorage.set", error, new_version);
                    }
                    // check new_version
                    if (new_version) {
                        await me.checkVersion(new_version);
                    }
                    me.last_version_check = moment();
                    resolve();
                } catch (error) {
                    /* suppress get server data error */
                    me._objObsInjectHelper.coreLogService.error("CoreUpdateService.check", "getting new version", error);
                    // error by get version from server, check the storaged data
                    await me.checkStoragedVersion();
                    resolve();
                }
            });
        }
    }

    private getNewVersionFromServer(): Promise<VersionModel> {
        const me = this;
        return me._objObsInjectHelper.yourAppServer.Api.GetNewVersion();
    }

    /** loads version from storage and checks it */
    private checkStoragedVersion(): Promise<void> {
        const me = this;
        return new Promise<void>((resolve) => {
            // load stored data
            me._objObsInjectHelper.coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.versionData)
                .then(async (stored_version) => {
                    if (stored_version) {
                        const new_version = <VersionModel>stored_version;
                        // check the stored version
                        await me.checkVersion(new_version);
                    }
                    // last_version_check not set, because it is only the storage
                    resolve();
                }).catch((error) => {
                    /* suppress get server data error */
                    me._objObsInjectHelper.coreLogService.error("CoreUpdateService.checkStoragedVersion", "valueStorage.get", error);
                    resolve();
                });
        });
    }

    /** checks the new version and notify or redirect if needs */
    private checkVersion(new_version: VersionModel): Promise<void> {
        const me = this;

        // check the version
        if (new_version.version !== appConfig.version) { // if new version != version > continue check
            if (new_version.force) { // if force > redirect to need update page
                me.is_redirected = true; // verhindert weitere prüfung
                me._objObsInjectHelper.coreLogService.error("CoreUpdateService.checkVersion", "TODO current version is obsolet and new must load, needs a redirect", appConfig.version, new_version);
                me.openWarningDialogUpdateAppForced(new_version.version);
            } else if (new_version.notify) { // if notify > notify about new version
                // new_version.obsolet_ymd > 0
                me.openAnnounceDialogUpdateAppOptionally(new_version.version);
                me._objObsInjectHelper.coreLogService.error("CoreUpdateService.checkVersion", "TODO existst a new version, needs a notification", appConfig.version, new_version);
            }
            // else; has new version, but dont need to do something
        }
        // else; current version is the newest version

        return Promise.resolve();
    }

    public openAnnounceDialogUpdateAppOptionally(version: string) {
        const me = this;
        const buttomSheet = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
            data: {
                title: "phUpdate_App_Optionally_Dialog_Header"
                , content: me.setAnnounceContentDescription(version)
                , firstBtnLabel: "phUpdate_App_Optionally_Dialog_Btn_Update"
                , secondBtnLabel: "phGlobal_Return"
            },
            panelClass: "mat-bottom-sheet-container-medium"
        });
        buttomSheet.afterDismissed().subscribe((result: AnounceModalResult) => {
            if (result === AnounceModalResult.FirstButton) {
                me.openAppInStrore();
            } else if (result === AnounceModalResult.SecondButton) {
                //do nothing
            } else {
                // nothing
            }
        });
    }

    private openWarningDialogUpdateAppForced(version: string) {
        const me = this;
        const buttomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
            data: {
                title: "phUpdate_App_Forced_Dialog_Header"
                , content: me.setWarningContentDescription(version)
                , btnLabel: "phUpdate_App_Forced_Dialog_Btn_Update"
            },
            disableClose: true,
            panelClass: "mat-bottom-sheet-container-medium"
        });
        buttomSheet.afterDismissed().subscribe((res) => {
            if (res) {
                me.openAppInStrore();
            }
        })
    }

    /**opens the app in the GoogleStore or AppStore depending on the device */
    public openAppInStrore() {
        const me = this;
        try {
            if (me._coreCOMService.environment.client.type === ClientType.android) {
                window.open(environment.storeURL.GooglePlayStore);
            } else {
                window.open(environment.storeURL.AppleStore);
            }
        } catch (e) {
            me._coreLogService.error("CoreUpdateService.onExternIntent", "window.open, open application", e);
        }
    }

    public setAnnounceContentDescription(version: string) {
        const me = this;
        return me._coreLanguageService.value("phUpdate_App_Optionally_Dialog_Description")
            .replace("{versionsNummer}", version);
    }

    public setWarningContentDescription(version: string) {
        const me = this;
        return me._coreLanguageService.value("phUpdate_App_Forced_Dialog_Description")
            .replace("{versionsNummer}", version);
    }
}
